module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_IG_red-8d33c228560d26b9d6840924a8d30918.svg";